<div class="flex flex-col basis-full m-20">
  <div class="flex flex-row display" mat-dialog-content>
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    <div class="flex flex-col items-center mt-16">
      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
      <div class="flex flex-row fw-700 fs-24 failed-title mt-16">{{title}}
        <ng-container *ngIf="isErrorMessages">
          <button class="flex flex-row ml-20 justify-end h-30 error-copy-class" [ngClass]="[copy ? 'copied': 'copy']" (click)="copyText(errorMessage)">
            <span *ngIf="!copy" class="flex flex-row fs-12 fw-400 item">
              <mat-icon class="h-14 w-14" svgIcon="content_copy"></mat-icon>
              <span>{{ 'ERRORS.COPY' | transloco }}</span>
            </span>
            <span *ngIf="copy" class="flex flex-row fs-12 fw-400 item">
              <mat-icon class="h-14 w-14 mt-2" svgIcon="check"></mat-icon>
              <span>{{ 'ERRORS.COPIED' | transloco }}</span>
            </span>
          </button>
        </ng-container>
      </div>
      <div class="flex flex-row w-100-percent">
        <div class="flex justify-center items-center w-100-percent fw-500 fs-16 failed_description_response mt-16">{{ description }}
          <span *ngIf="descriptionArray" class="items-center fw-500 fs-14 error-description-count">{{'(' + descriptionArrayLength + ')'}}</span>
          <a *ngIf="descriptionArray" class="items-center fw-400 fs-14 ml-10" href="javascript:void(0)" (click)="onClick()">{{defaultLinkTitle}}</a>
        </div>
      </div>
      <div *ngIf="defaultLinkTitle === defaultLinkTitleLess" class="w-100-percent mt-20">
        <button class="flex justify-end h-30 error-copy-class" [ngClass]="[copy ? 'copied': 'copy']" *ngIf="descriptionArray && defaultLinkTitle === defaultLinkTitleLess" (click)="copyText(descriptionArray)">
          <span *ngIf="!copy" class="fs-12 fw-400 item">
            <mat-icon class="h-14 w-14" svgIcon="content_copy"></mat-icon>{{ 'ERRORS.COPY' | transloco }}
          </span>
          <span *ngIf="copy" class="fs-12 fw-400 item">
            <mat-icon class="h-14 w-14" svgIcon="check"></mat-icon>{{ 'ERRORS.COPIED' | transloco }}
          </span>
        </button>
      </div>
      <mat-divider></mat-divider>
      <div *ngIf="defaultLinkTitle === defaultLinkTitleLess" class="overflow-class w-100-percent p-16" >
        <div *ngFor="let description of descriptionArray">{{description.message}}
          <mat-divider *ngIf="descriptionArrayLength !== 1" class="dropdown-divider mt-8 mb-16"></mat-divider>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-center items-center mb-20 mt-36">
    <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'BLUEPRINT_SUMMARY.ERROR.BACK' | transloco }} </button>
    <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'BLUEPRINT_SUMMARY.ERROR.REPORT' | transloco }} </button>
  </div>
</div>
